﻿import { RESTError } from "../../API/RESTError";
import { DefaultParameterDefinitions } from "../../DefaultParameterDefinitions";
import { GetHistoricalForecastResponse } from "../../InfluxDb/GetHistoricalForecastResponse";
import { InfluxDataWrapper } from "../../InfluxDb/InfluxDataWrapper";
import { getHistoricData, getHistoricForecastData } from "../../InfluxDb/InfluxDb";
import { MainSite } from "../../MainSite";
import { ParameterDefinition } from "../../Model/ParameterDefinition";
import { ParameterTree, VariantNodeData } from "./ParameterTree";
import { PlottingPage } from "./PlottingPage";
import { IUnitsConversionSet } from "../../Converters/UnitsConverter/IUnitsConverter";

export class AddIssueDialog {
    constructor(private stationId: string, private sensorId: string, private parameterId: string, private plottingPage: PlottingPage, private parameterTree: ParameterTree, private parameterTreeNode: Fancytree.FancytreeNode) {
    }

    private modal: JQuery = null;
    private modalBody: JQuery = null;

        private contentContainer: JQuery = null;

        // 6h is often more reliable that 1h or 2h for specific sites (e.g. Forcados ng)
        private fallbackVariantStr: string = '6h';

    public show(): void {
        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalContent = $('<div class="modal-content"></div>')
            .appendTo($('<div class="modal-dialog"></div>').appendTo(this.modal));

        var modalHeader = $('<div class="modal-header"></div>').appendTo(modalContent);
        $('<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>').appendTo(modalHeader);

        $('<h4 class="modal-title"></h4>').text("Add Forecast Issue").appendTo(modalHeader);

        this.modalBody = $('<div class="modal-body" id="midi_PlottingPage_modal_add_issue_body"></div>').appendTo(modalContent);

        this.contentContainer = $('<div></div>')
            .appendTo(this.modalBody);

        //download last 5 days issue times
        this.getLastXDaysIssues(moment.tz(MainSite.instance.getTimeZoneName()), 5);

        var modalFooter = $('<div class="modal-footer"></div>').appendTo(modalContent);
        $('<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>')
            .click(() => {
                this.issues = [];
            })
            .appendTo(modalFooter);

        this.continueButton = $('<button type="button" class="btn btn-success disabled">Add Issue</button>')
            .appendTo(modalFooter)
            .click(() => {
                if (this.issues.length === 0) {
                    return;
                }

                this.issues.forEach(issue => {
                    this.addIssue(issue); 
                });       

                this.modal.modal('hide');
            });
        $('<form method="post" action="api/HistoricalData/Get" enctype="application/x-www-form-urlencoded"></form>').appendTo(modalFooter);

        this.modal.on("shown.bs.modal", (e) => {
            this.plottingPage.pageUnblock();
        });
        this.modal.modal('show');
    }

        private getLastXDaysIssues(selectedDate: moment.Moment, numberOfDays: number, overrideVariant?: string) {
            this.contentContainer.empty();

        $('<div>').addClass('AddIssueDialog--Spinner text-muted')
            .appendTo(this.contentContainer)
            .append($('<div>')
                .html('<i class="fa fa-spin fa-refresh"></i> <span>Loading issue times</span>'));

        let momentTo = selectedDate.startOf('day').add(1, 'd');
        let momentFrom = moment(momentTo).subtract(numberOfDays, 'days');

            // Use the override if provided, otherwise find the base variant
            let baseVariantStr = overrideVariant || this.findBaseVariant();

            if (baseVariantStr === null) {
                // Fallback to '0h' if no variant could be determined
                baseVariantStr = '0h';
            }

            getHistoricData(
                'P',  // Assume data will be coming from RDS for now
                this.stationId,
                this.sensorId,
                this.parameterId,
                baseVariantStr,
                momentFrom.valueOf(),
                momentTo.valueOf(),
                (err: any, data: InfluxDataWrapper) => {

                    // Fallback: If the 0h variant exists but has no data in the queried time range; try the fallbackVariantStr instead.
                    if (!err && data.Data.length === 0) {
                        this.getLastXDaysIssues(selectedDate, numberOfDays, this.fallbackVariantStr);
                        return; // Stop processing this empty response
                    }

                    this.contentContainer.empty();

                    if (err) {
                        this.contentContainer.append($('<span>Error getting data: ' + JSON.stringify(err) + '</span>'));
                        return;
                    }

                    let allowedTs = data.Data.map((pair: number[]) => {
                        let issueHours = parseFloat(baseVariantStr.replace(/h/g, ""));
                        let adjustedTs = pair[0] - (issueHours * 3600000);

                    return {
                        issueTime: adjustedTs,
                        mom: moment.tz(adjustedTs, MainSite.instance.getTimeZoneName())
                    };
                });

                let rows: { dateStr: string, rowContent: JQuery }[] = [];

                allowedTs.forEach(ts => {
                    this.populateTsRows(ts, rows, baseVariantStr);
                });

                let datepicker = $('<input class="input-sm form-control" placeholder="Issue Date" type="text" id="midi_AddIssueDialog_date_picker" aria-describedby="basic-addon2"></input>')
                    .css("width", "130px")
                    .css("margin-right", "10px")
                    .css("display", "inline-block")
                    .datepicker({
                        format: "yyyy-mm-dd",
                        maxDate: moment.tz(MainSite.instance.getTimeZoneName()).format("YYYY-MM-DD")
                    } as any);

                    if (rows.length === 0) {
                        datepicker
                            .on('changeDate', () => {
                                //Get the list of issue times using the 0h variant
                                //let's not clear the selected issues here, even if the date changes and it won't be displayed any longer
                                let selectedDate = moment.tz(datepicker.val() as string, 'YYYY-MM-DD', MainSite.instance.getTimeZoneName());
                                datepicker.datepicker('hide');
                                this.getLastXDaysIssues(selectedDate, 5); // Initial call will use findBaseVariant()
                            })
                            .appendTo(this.contentContainer);
                        $('<div></div>').css("display", "inline-block").text("No issue times for selected date").appendTo(this.contentContainer);
                        return;
                    }

                rows.sort((a, b) => {
                    return new Date(b.dateStr).getTime() - new Date(a.dateStr).getTime();
                });

                    for (let i = 0; i < rows.length; i++) {
                        if (i === 0) {
                            datepicker.on('changeDate', () => {
                                //Get the list of issue times using the 0h variant
                                if (datepicker.val() !== rows[i].dateStr) {
                                    //let's not clear the selected issues here, even if the date changes and it won't be displayed any longer
                                    let selectedDate = moment.tz(datepicker.val() as string, 'YYYY-MM-DD', MainSite.instance.getTimeZoneName());
                                    datepicker.datepicker('hide');
                                    this.getLastXDaysIssues(selectedDate, 5);
                                }
                            })
                                .prependTo(rows[i].rowContent);

                            datepicker.datepicker('setDate', rows[i].dateStr);
                        }
                        else {
                            rows[i].rowContent.prepend($('<div></div>')
                                .css("width", "130px")
                                .css("margin-left", "10px")
                                .css("display", "inline-block")
                                .text(rows[i].dateStr));
                        }
                        this.contentContainer.append(rows[i].rowContent);
                    }
                },
                -1
            );
        }

    private populateTsRows(ts: { issueTime: number, mom: moment.Moment }, rows: {dateStr: string, rowContent: JQuery}[], baseVariant: string) {
        let dateStr = ts.mom.format("YYYY-MM-DD");

        let row_ = rows.filter(x => x.dateStr === dateStr);

        if (row_.length === 0) {
            rows.push({
                dateStr: dateStr,
                rowContent: $('<div></div>').css("margin-bottom", "3px")
            });
        }

        let row = rows.filter(x => x.dateStr === dateStr)[0];

        $('<div class="btn btn-default midi_add-issue-ts" id="' + ts.issueTime + '"></div>')
            .text(ts.mom.format("HH:mm") + " " + MainSite.instance.getTimeZoneString())
            .click(() => {
                let filtIssues = this.issues.filter(x => x.issueTime === ts.issueTime);
                $('.midi_add-issue-ts')
                    .removeClass("selected");

                if (filtIssues.length === 0) {
                    $('#' + ts.issueTime)
                        .append($('<i class="fa fa-spin fa-refresh" id="spinner_' + ts.issueTime + '"></i>').css("margin-left", "0.2em"));

                    $('.midi_add-issue-ts')
                        .addClass("disabled");

                    this.continueButton
                        .addClass("disabled");

                    this.getIssue(ts.issueTime, baseVariant, this.updateContinueButton.bind(this));
                }
                else {
                    let idx = this.issues.indexOf(filtIssues[0]);
                    this.issues.splice(idx,1);
                    this.updateContinueButton();
                }

                this.issues.forEach((issue) => {
                    $('#' + issue.issueTime)
                        .addClass("selected");
                });
            })
            .appendTo(row.rowContent);
    }

    private updateContinueButton() {
        if (this.issues.length > 1) {
            this.continueButton.text("Add Issues");
        }
        else {
            this.continueButton.text("Add Issue");
        }

        if (this.issues.length === 0) {
            this.continueButton.addClass("disabled");
        }
        else {
            this.continueButton.removeClass("disabled");
        }
    }

    private issues: { issueTime: number, issue: GetHistoricalForecastResponse }[] = [];

    private addIssue(issue: { issueTime: number, issue: GetHistoricalForecastResponse }) {
        let chartData: [number, number][] = [];
        issue.issue.Rows.forEach((row) => {
            let val = (row.Value !== null && row.Value !== "") ? parseFloat(row.Value) : null;
            if (val !== null) {
                chartData.push([
                    row.Timestamp_ms,
                    val
                ]);
            }
        });

        chartData.sort((a, b) => {
            return a[0] - b[0];
        });

        //TODO: address Highcharts error 15 data not sorted with consideration of the below
        //It looks like chartData.sort is working properly

        //There is a weird behaviour here that I spent a lot of time getting stuck over, convinced that
        //the sort wasn't working properly. Have left the logs here just in case we run into this issue again somewhere.
        //Highcharts (on line below, addOrUpdateChartSeries) modifies the chartData array to add an element at the start
        //and an element at the end. So console.log(chartData) actually gives us an array that is n+2 of the correct
        //array length. E.g. console.log(chartData) shows an array of length 74 but on the line below
        //console.log("chartData length: " + chartData.length) shows 72.
        //This is interesting because we can't then rely on the integrity of chartData AFTER the Highcharts render,
        //because Highcharts might have changed it!
        //console.log(chartData);
        //console.log("chartData length: " + chartData.length);

        var parameterDefinition: ParameterDefinition = this.plottingPage.mainSite.staticDataManager.Schema.ParameterSchema.Stations[this.stationId].Sensors[this.sensorId].Parameters[this.parameterId].Variants[0].ParameterDefinition;

        if (!parameterDefinition || parameterDefinition.Default) {
            parameterDefinition = DefaultParameterDefinitions.Parameters[this.parameterId];
        }

        let d = {
            Store: 'P',
            StationId: this.stationId,
            SensorId: this.sensorId,
            ParameterId: this.parameterId,
            Data: chartData,
            ParameterDefinition: parameterDefinition ? parameterDefinition : null,
            VariantId: "Issue: " + moment.tz(issue.issue.RequestedIssueTime, MainSite.instance.getTimeZoneName()).format("YYYY-MM-DD HH:mm").toString() + ' ' + MainSite.instance.getTimeZoneString()
        };

        // Get unit conversion
        let unitsConversionSet: IUnitsConversionSet | null = MainSite.getUnitConverter().getConversionSet(parameterDefinition?.Units ?? '', this.parameterId);
        
        // Apply unit conversion
        if (unitsConversionSet) {
            d.Data = d.Data.map(x => {
                if (Array.isArray(x) && x.length == 2) {
                    return <[number, number]>[x[0], unitsConversionSet.convertValue(x[1])];
                }
                return x;
            });
        }

        if (this.plottingPage.plotData.length === 0) {
            //zoom to data extent if no other data series
            this.plottingPage.setDateRange(moment.utc(chartData[0][0]), moment.utc(chartData[chartData.length - 1][0]));
        }

        this.plottingPage.addOrUpdateChartSeries(d);

        let paramNode = this.findParamNode();
        if (paramNode) {
            paramNode.addChildren(this.getNewNode(issue.issue.RequestedIssueTime, d), 0);//Add at the top
        }
    }

    private getIssue(issueTime: number, baseVariant: string, then: () => any) {
        getHistoricForecastData((err: RESTError, resp: GetHistoricalForecastResponse) => {
            $('.midi_add-issue-ts')
                .removeClass("disabled");

            $('#spinner_' + issueTime).remove();

            if (err) {
                alert("Error getting issue: " + JSON.stringify(err));
                this.continueButton.addClass("disabled");
                return;
            }

            $('#' + issueTime).addClass('selected');

            this.continueButton
                .removeClass('disabled');

            this.issues.push({ issueTime: issueTime, issue: resp });
            then();

        }, 'P', this.stationId, this.sensorId, this.parameterId, issueTime, baseVariant);
    }

    private findBaseVariant(): string {
        let paramNode = this.findParamNode();

        if (paramNode === null) {
            return null;
        }

            let variants = (paramNode.children as unknown) as VariantNodeData[];

        if (variants.length === 0) {
            console.log("Variants not found! station: " + this.stationId + ", sensor: " + this.sensorId + ", param: " + this.parameterId);
            return null;
        }

        let variantNames = variants.map(x => x.title).filter(x => x !== "Latest" && x.indexOf("Issue") === -1).map(x => ({ s: x, f: parseFloat(x.replace(/h/g, "")) })).sort((a, b) => { return a.f - b.f; });
        let lowestVariant = variantNames[0];

            if (lowestVariant.f !== 0) {
                //if we dont have 0 then check for the fallbackVariantStr
                if (variantNames.some(x => x.s === this.fallbackVariantStr)) {
                    return this.fallbackVariantStr;
                }
            }

        return lowestVariant.s;
    }

    private findParamNode(): Fancytree.FancytreeNode {
        this.parameterTreeNode.setExpanded();
        return this.parameterTreeNode;

        let siteNode = this.parameterTree.fancyTree.rootNode.findFirst((node) => {
            return node.key === this.stationId;
        });
        if (siteNode) {
            let sensorNode = siteNode.findFirst((node) => {
                return node.title === this.sensorId;
            });
            if (sensorNode) {
                let paramNode = sensorNode.findFirst(this.parameterId);
                if (paramNode) {
                    paramNode.setExpanded();
                    return paramNode;
                }
            };
        }
        console.log("Node not found! station: " + this.stationId + ", sensor: " + this.sensorId + ", param: " + this.parameterId);
        return null;
    }

    private removeNode(key: string, d: InfluxDataWrapper) {
        let node = this.findParamNode();
        let childNode = this.parameterTree.fancyTree.rootNode.findFirst((node) => {
            return node.key === key;
        });

        node.removeChild(childNode);
        this.plottingPage.removeChartSeries(d);
    }

    private getNewNode(ts: number, d: InfluxDataWrapper): Fancytree.NodeData {
        let key = this.stationId + "|" + this.sensorId + "|" + this.parameterId + "|" + "issue_" + ts;
        return {
            key: key,
            title: "Issue: " + moment.tz(ts, MainSite.instance.getTimeZoneName()).format("YYYY-MM-DD HH:mm").toString() + ' ' + MainSite.instance.getTimeZoneString(),
            selected: true,
            icon: '/images/icons/lineChartIcon.png',
            data: {
                hideData: () => {
                    //remove node and remove line from chart
                    this.removeNode(key, d);
                },
                showData: () => {
                    //just need to implement for chart refresh and when change dates
                    //but we don't need to download again - just filter data based on selected dates
                    let filteredData = [];
                    let mm = this.plottingPage.getCurrentMoments();

                    d.Data.forEach((d: [number, number]) => {
                        if (d[0] >= mm.from.valueOf() && d[0] <= mm.to.valueOf()) {
                            filteredData.push(d);
                        }
                    });

                    let updatedData = { ...d };
                    updatedData.Data = filteredData;
                    this.plottingPage.addOrUpdateChartSeries(updatedData);
                },
                refreshData: () => {
                    //blank implementation - there will not be any updated data for this series
                }
            }
        }
    }

    private continueButton: JQuery = null;

    public hide(): void {
        if (this.modal) {
            this.modal.remove();
        }
    }
}

 